<template>
    <navbar btnBackground="bg-gradient-warning" />
    <div class="page-header align-items-start min-vh-100"
        :style="{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
        <!-- <div class="page-header align-items-start min-vh-100" style="
                      background-image: url('https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80');
                    "> -->

        <span class="mask bg-gradient-dark opacity-6"></span>

        <div class="container mb-3">
            <div class="row">
                <div class="header pt-6 w-100  d-flex justify-content-center">
                    <div class="container">
                        <div class="header-body text-center mb-5">
                            <div class="row justify-content-center">
                                <div class="text-center" style="margin-bottom: 5px;">
                                    <h3 style="color: #CBA048;"> Log in to Rocket Admin
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-8 col-12 mx-auto pb-5">
                    <div class="card z-index-0 fadeIn3 fadeInBottom">
                        <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                            <div class="bg-gradient-warning shadow-warning border-radius-lg py-3 pe-1">
                                <h4 class="text-white font-weight-bolder text-center mt-2 mb-0">
                                    Sign in
                                </h4>
                                <div class="row mt-3">
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <Form role="form" class="text-start mt-3" :validation-schema="schema" @submit="handleLogin">
                                <div class="mb-3">
                                    <material-input-field id="email" v-model:value="user.email" type="text"
                                        label="Email" name="email" variant="static" />
                                </div>
                                <div class="mb-3">
                                    <material-input-field id="password" v-model:value="user.password" type="password"
                                        label="Password" name="password" variant="static" />
                                </div>
                                <div class="text-center mt-4">
                                    <material-button class="my-4 mb-2" variant="gradient" color="warning" full-width>
                                        <span>Sign in</span>
                                    </material-button>
                                </div>
                                <!-- <p class="mt-4 text-sm text-center">
                                    Don't have an account?
                                    <router-link :to="{ name: 'Signup' }"
                                        class="text-warning text-gradient font-weight-bold">Sign
                                        up</router-link>
                                </p>
                                <p class="text-sm text-center">
                                    <router-link :to="{ name: 'Password Forgot' }"
                                        class="text-warning text-gradient font-weight-bold">Recover
                                        Password</router-link>
                                </p> -->
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import showSwal from "@/mixins/showSwal";
import { mapMutations } from "vuex";
import { Form } from "vee-validate"
import * as Yup from 'yup'

export default {
    name: "Login",
    components: {
        Navbar,
        MaterialInputField,
        MaterialButton,
        Form,
    },
    data() {
        return {
            backgroundImage: require('@/assets/img/unsplash_U7c8rTBwc0c.png'),
            user: {
                email: "",
                password: null,
            },
            schema: Yup.object().shape({
                // username: Yup.string().email("Username has to be a valid").required("Username is a required input"),
                email: Yup.string().required("Email is a required input"),
                password: Yup.string().required("Password is a required input")
            }),
        };
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.loggedIn;
        }
    },
    beforeMount() {
        this.toggleEveryDisplay();
        this.toggleHideConfig();
    },
    beforeUnmount() {
        this.toggleEveryDisplay();
        this.toggleHideConfig();
    },
    methods: {
        ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
        async handleLogin() {
            try {
                const response = await this.$store.dispatch('auth/login', this.user);
                if (response) {
                    if (response.type === 'admin') {
                        this.$router.push({ name: 'Dashboard' });
                    } else {
                        showSwal.methods.showSwal({
                            type: "error",
                            message: "You are not authorized to access this panel!",
                            width: 500
                        });
                    }
                } else {
                    showSwal.methods.showSwal({
                        type: "error",
                        message: response.message || "Login failed. Please try again.",
                        width: 500
                    });
                }
            } catch (error) {
                showSwal.methods.showSwal({
                    type: "error",
                    message: "An error occurred. Please try again.",
                    width: 500
                });
            }
        },
    },
};
</script>
